<template>
  <div class="content container-fluid">
    <!-- Page Header -->
    <div class="page-header">
      <div class="row align-items-center">
        <div class="col">
          <h3 class="page-title">Add E-Coupon</h3>
        </div>
      </div>
    </div>
    <!-- /Page Header -->

    <form @submit.prevent="saveEcoupon">
      <div class="row">
        <div class="col-md-12">
          <div class="card">
            <div class="card-body">
              <div class="form-row" v-if="tokenObj.role == 'admin'">
                <div class="form-group col-md-6">
                  <label>Merchant</label>
                  <select class="form-control" v-model="merchant" required>
                    <option value>-- Select Merchant --</option>
                    <option value="Burger King">Burger King</option>
                    <option value="KFC">KFC</option>
                    <option value="McDonald's">McDonald's</option>
                    <option value="Pizza Hut">Pizza Hut</option>
                  </select>
                </div>
              </div>
              <div class="form-row">
                <div class="col-md-7">
                  <div class="form-row">
                    <div class="form-group col-md-4 fit-content">
                      <label>Type</label>
                      <select class="form-control" v-model="type" required>
                        <option value>-- Select Type --</option>
                        <option value="Running Number">Running Number</option>
                        <option value="Limited Redemption">
                          Limited Redemption
                        </option>
                        <option value="Adhoc">Adhoc</option>
                      </select>
                    </div>
                    <div
                      class="form-group col-md-4 fit-content"
                      v-if="type == 'Running Number'"
                    >
                      <label style="word-spacing: -3px; font-size: 14px">
                        Running Number Start from
                      </label>
                      <input
                        type="number"
                        v-model="runningNumberStart"
                        class="form-control"
                        required
                      />
                    </div>
                    <div class="form-group col-md-4" style="max-width: 192px">
                      <label>Code</label>
                      <input
                        style="font-size: 13px"
                        type="text"
                        v-model="code"
                        class="form-control"
                        maxlength="50"
                        required
                      />
                    </div>
                  </div>
                </div>
                <div class="col-md-5">
                  <div class="form-row">
                    <div class="form-group col-md-4">
                      <label>Start Date</label>
                      <input
                        type="date"
                        v-model="startDate"
                        class="form-control"
                      />
                    </div>
                    <div class="form-group col-md-4">
                      <label>Expiry Date</label>
                      <input
                        type="date"
                        v-model="expiryDate"
                        class="form-control"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div class="form-row">
                <div class="form-group col-md-3">
                  <label>Discount Type</label>
                  <select class="form-control" v-model="discountType" required>
                    <option value>-- Select Discount Type --</option>
                    <option value="Percentage Discount">
                      Percentage Discount
                    </option>
                    <option value="Amount Discount">Amount Discount</option>
                  </select>
                </div>
                <div class="form-group col-md-3">
                  <label v-if="discountType">
                    Discount Amount ({{
                      discountType == "Percentage Discount" ? "%" : "$"
                    }})
                  </label>
                  <label v-else>Discount Amount</label>
                  <input
                    type="number"
                    v-model="discountAmount"
                    class="form-control"
                    required
                  />
                </div>
                <div class="mx-5"></div>
                <div class="form-group col-md-3">
                  <label>Distribution Channel</label>
                  <select
                    class="form-control"
                    v-model="distributionChannel"
                    required
                  >
                    <option value>-- Select Channel --</option>
                    <option value="Email">Email</option>
                    <option value="Portal">Portal</option>
                  </select>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-md-12">
          <div class="card">
            <div class="card-header text-center pb-0">
              <h3>Recipients</h3>
            </div>
            <div class="card-body">
              <div class="form-group row align-items-center">
                <label class="col-md-1">Age from</label>
                <div class="col-md-1 px-0">
                  <input
                    type="number"
                    v-model="ageFrom"
                    class="form-control form-control-sm"
                  />
                </div>
                <label class="col-md-1 fit-content">to</label>
                <div class="col-md-1 px-0">
                  <input
                    type="number"
                    v-model="ageTo"
                    class="form-control form-control-sm"
                  />
                </div>
                <div class="col-md-1 pr-0">
                  <select
                    class="form-control form-control-sm"
                    v-model="operator"
                  >
                    <option value></option>
                    <option value="And">And</option>
                    <option value="Or">Or</option>
                  </select>
                </div>
                <label class="col-md-2 fit-content">Gender is</label>
                <div class="col-md-1 px-0">
                  <select class="form-control form-control-sm" v-model="gender">
                    <option value>All</option>
                    <option value="Male">Male</option>
                    <option value="Female">Female</option>
                  </select>
                </div>
                <div class="col-md-1">
                  <button type="button" class="btn btn-sm btn-primary">
                    Filter
                  </button>
                </div>
              </div>
              <div class="row">
                <div class="col-md-12">
                  <input type="checkbox" /> <label>All Customers</label><br />
                  <input type="checkbox" /> <label>Andy (andy@gmail.com)</label>
                  <br />
                  <input type="checkbox" />
                  <label>Adam (adam@outlook.com)</label>
                  <br />
                  <input type="checkbox" />
                  <label>Susan (susan@outlook.com)</label>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="text-center">
        <button type="button" class="btn btn-danger">Cancel</button>
        <button type="button" class="btn btn-secondary">Save as Draft</button>
        <button type="submit" class="btn btn-primary">Send</button>
      </div>
    </form>
  </div>
</template>

<script>
import API from "../../http-common.js";
export default {
  data() {
    return {
      merchant: "",
      type: "",
      code: "",
      runningNumberStart: 1,
      startDate: "",
      expiryDate: "",
      discountType: "",
      discountAmount: null,
      distributionChannel: "",
      remarks: "",
      customers: [],
      //filter recipients
      ageFrom: 17,
      ageTo: 35,
      operator: "And",
      gender: "",
    };
  },
  computed: {
    tokenObj() {
      let data = JSON.parse(localStorage.getItem("emstoken"));
      return data;
    },
  },
  watch: {
    type(val) {
      if (val == "Running Number") {
        let merchant = "";
        if (this.tokenObj.role == "admin") merchant = this.merchant;
        else merchant = this.tokenObj.merchant;
        let codePrefix = "";
        if (merchant == "Burger King") codePrefix = "BRK";
        else if (merchant == "KFC") codePrefix = "KFC";
        else if (merchant == "McDonald's") codePrefix = "MCD";
        else if (merchant == "Pizza Hut") codePrefix = "PHT";
        this.code = codePrefix + "-[#RunningNumber#]";
      } else this.code = "";
    },
    merchant(val) {
      if (this.type == "Running Number") {
        let codePrefix = "";
        if (val == "Burger King") codePrefix = "BRK";
        else if (val == "KFC") codePrefix = "KFC";
        else if (val == "McDonald's") codePrefix = "MCD";
        else if (val == "Pizza Hut") codePrefix = "PHT";
        this.code = codePrefix + "-[#RunningNumber#]";
      }
    },
  },
  methods: {
    saveEcoupon() {},
  },
  created() {},
};
</script>




// WEBPACK FOOTER //
// src/components/Share/EcouponEdit.vue